import { useCallback, useContext, useEffect, useState } from 'react';
import { Transition } from 'react-transition-group';
import Media from 'react-media';

import { SideMenuContext } from '@/pages/CompanyReport/components/Overview/components/SideMenu/context';

import useWindowSize from '@/hooks/useWindowSize';
import { Portal } from '@/components/Portal';

import { Container, TransformerContainer, Dimmer } from './styled';

export const SideMenu = () => {
  const sideMenuContext = useContext(SideMenuContext);
  const isVisibleRef = sideMenuContext.isVisibleRef;
  const { width: screenWidth } = useWindowSize();
  const [enter, setEnter] = useState(false);

  const onEntered = useCallback(() => {
    isVisibleRef.current = true;
  }, [isVisibleRef]);
  const onExit = useCallback(() => {
    isVisibleRef.current = false;
  }, [isVisibleRef]);

  useEffect(() => {
    if (typeof sideMenuContext.showMenu !== 'undefined') {
      setEnter(sideMenuContext.showMenu);
    }
  }, [sideMenuContext.showMenu]);
  return (
    <Media
      queries={{
        mobile: { maxWidth: 1023 },
        fixed: { minWidth: 1582 },
        rightAlignOverlay: { minWidth: 1023, maxWidth: 1439 },
        rightAlignFixed: { minWidth: 1440, maxWidth: 1582 },
      }}
    >
      {(matches) => {
        const baseTimeout = 600;
        //TODO @victorc: below timeout condition & isVisibleRef can be removed after full split rollout
        //Prevent transitions from replaying when switching between split / non-split variant
        const timeout = isVisibleRef.current ? 0 : baseTimeout;
        let leftPosition = '0px';
        if (matches.fixed) {
          leftPosition =
            typeof screenWidth !== 'undefined'
              ? `${screenWidth * 0.5 + 816 * 0.5}px`
              : leftPosition;
        }
        if (matches.rightAlignFixed) {
          leftPosition =
            typeof screenWidth !== 'undefined'
              ? `${screenWidth * 0.5 + 650 * 0.5}px`
              : leftPosition;
        }
        if (matches.rightAlignOverlay || matches.mobile) {
          leftPosition = matches.mobile ? '0px' : 'auto';
          return (
            <Portal portalId="floating-side-menu">
              <Transition
                timeout={{
                  appear: timeout,
                  enter: timeout,
                  exit: baseTimeout,
                }}
                in={enter}
                onEntered={onEntered}
                onExit={onExit}
              >
                {(state) => {
                  if (state === 'exited') return null;
                  const exiting = state === 'exiting' || state === 'unmounted';
                  return (
                    <>
                      <Container left={leftPosition}>
                        <TransformerContainer
                          data-cy-id="side-menu-transformer-container"
                          timeout={exiting ? baseTimeout : timeout}
                          status={state}
                        >
                          {typeof sideMenuContext.menuElement !== 'undefined'
                            ? sideMenuContext.menuElement
                            : null}
                        </TransformerContainer>
                      </Container>
                      <Dimmer
                        onClick={() => sideMenuContext.setShowMenu('closed')}
                      />
                    </>
                  );
                }}
              </Transition>
            </Portal>
          );
        }

        return (
          <Transition
            timeout={{
              appear: timeout,
              enter: timeout,
              exit: baseTimeout,
            }}
            in={enter}
            onEntered={onEntered}
            onExit={onExit}
          >
            {(state) => {
              if (state === 'exited') return null;
              const exiting = state === 'exiting' || state === 'unmounted';
              return (
                <>
                  <Container left={leftPosition}>
                    <TransformerContainer
                      data-cy-id="side-menu-transformer-container"
                      timeout={exiting ? baseTimeout : timeout}
                      status={state}
                    >
                      {typeof sideMenuContext.menuElement !== 'undefined'
                        ? sideMenuContext.menuElement
                        : null}
                    </TransformerContainer>
                  </Container>
                </>
              );
            }}
          </Transition>
        );
      }}
    </Media>
  );
};
